import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { CampaignConfigCategoryView, CampaignConfigView } from '../types';

interface CampaignConfigState {
  activeCategories: CampaignConfigCategoryView[];
  configs: CampaignConfigView[];
  usedConfigs: CampaignConfigView[];
  loading: boolean;
  lastFetchedCompanyId: string | null;
}

const initialState: CampaignConfigState = {
  activeCategories: [],
  configs: [],
  usedConfigs: [],
  loading: false,
  lastFetchedCompanyId: null,
};

const campaignConfigSlice = createSlice({
  name: 'campaignConfig',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setActiveCategories: (state, action: PayloadAction<CampaignConfigCategoryView[]>) => {
      state.activeCategories = action.payload;
    },
    setConfigs: (state, action: PayloadAction<CampaignConfigView[]>) => {
      state.configs = action.payload;
    },
    setConfigFavorite: (state, action: PayloadAction<{ id: string; favorite: boolean }>) => {
      const config = state.configs.find(item => item.id === action.payload.id);
      if (config) {
        config.favorite = action.payload.favorite;
      }
    },
    setUsedConfigs: (state, action: PayloadAction<CampaignConfigView[]>) => {
      state.usedConfigs = action.payload;
    },
    setLastFetchedCompanyId: (state, action: PayloadAction<string | null>) => {
      state.lastFetchedCompanyId = action.payload;
    },
  },
});

export const getActiveConfigCategories = (state: RootState): CampaignConfigCategoryView[] => state.campaignConfig.activeCategories;
export const getCampaignConfigs = (state: RootState): CampaignConfigView[] => state.campaignConfig.configs;
export const getUsedCampaignConfigs = (state: RootState): CampaignConfigView[] => state.campaignConfig.usedConfigs;
export const getCampaignConfigLoading = (state: RootState): boolean => state.campaignConfig.loading;
export const getLastFetchedCompanyId = (state: RootState): string | null => state.campaignConfig.lastFetchedCompanyId;

export const {
  setLoading,
  setActiveCategories,
  setConfigs,
  setConfigFavorite,
  setUsedConfigs,
  setLastFetchedCompanyId,
} = campaignConfigSlice.actions;

export const campaignConfigReducer = campaignConfigSlice.reducer;

